import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
export function VideoMockupSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const video = videoRef.current;
      // Si el video tiene duración y estamos a 3 o menos segundos del final, lo reiniciamos
      if (video.duration && video.currentTime >= video.duration - 3) {
        video.currentTime = 0;
        video.play();
      }
    }
  };
  return <section className="py-20 px-4 bg-[#0a0514] relative z-10 overflow-hidden flex justify-center items-center" data-id="element-335">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-337">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-4" data-id="element-338">
            ASÍ SE VE EL <span className="text-[#00f0ff]" data-id="element-339">RESULTADO</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-340">
            Mirá cómo queda el efecto infinito en la vida real. Un diseño que
            atrapa todas las miradas.
          </p>
        </motion.div>

        <motion.div initial={{
        scale: 0.5,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        type: 'spring',
        bounce: 0.4
      }} className="relative" data-id="element-341">
          {/* Phone Frame */}
          <motion.div initial={{
          borderColor: 'rgba(31, 31, 34, 1)',
          scale: 1
        }} whileInView={{
          borderColor: 'rgba(31, 31, 34, 0.1)',
          scale: 1.15
        }} transition={{
          duration: 3,
          ease: 'easeOut',
          delay: 0.5
        }} className="relative w-[300px] h-[600px] md:w-[350px] md:h-[700px] bg-black rounded-[3rem] border-[12px] shadow-[0_0_50px_rgba(0,240,255,0.15)] overflow-hidden flex justify-center" data-id="element-342">
            {/* Notch */}
            <motion.div initial={{
            opacity: 1,
            y: 0
          }} whileInView={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 2,
            ease: 'easeOut',
            delay: 0.5
          }} className="absolute top-0 w-40 h-7 bg-[#1f1f22] rounded-b-3xl z-20 flex justify-center items-center gap-2" data-id="element-343">
              <div className="w-2 h-2 rounded-full bg-[#0a0514]" data-id="element-344"></div>
              <div className="w-12 h-2 rounded-full bg-[#0a0514]" data-id="element-345"></div>
            </motion.div>

            {/* Video */}
            <motion.video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/noMMQPuLtV4u3koxaXG8iU/WhatsApp Video 2026-03-30 at 17.03.38.mp4" className="absolute inset-0 w-full h-full object-cover rounded-[2.2rem]" autoPlay muted playsInline onTimeUpdate={handleTimeUpdate} initial={{
            scale: 1
          }} whileInView={{
            scale: 1.1
          }} transition={{
            duration: 4,
            ease: 'easeOut',
            delay: 0.5
          }} data-id="element-346" />

            {/* Reflection / Glare effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent pointer-events-none rounded-[2.2rem]" data-id="element-347"></div>
          </motion.div>

          {/* Glow behind phone */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[#00f0ff]/20 blur-[100px] -z-10 rounded-full pointer-events-none" data-id="element-348"></div>
        </motion.div>
      </div>
    </section>;
}